<template>
<div class="chapter">
<div class="inner_page">
<p class="img"><img alt="" src="Images/frn_fig_003.png"/></p>
<h1 class="h1" id="sigil_toc_id_3"><span class="textStyle011">Illustrations and Tables</span></h1>
<h2 class="h2" id="sigil_toc_id_4"><span class="textStyle014">Photographs</span></h2>
<table width="99%">
<tbody><tr>
<td valign="top"><span class="textStyle9">Plutarco Elías Lucero</span></td>
<td class="right" valign="top"><span class="textStyle9">3</span></td>
</tr>
<tr>
<td valign="top"><span class="textStyle9">María Jesús Campuzano Noriega</span></td>
<td class="right" valign="top"><span class="textStyle9">4</span></td>
</tr>
<tr>
<td valign="top"><span class="textStyle9">Plutarco Elías Calles in the classroom</span></td>
<td class="right" valign="top"><span class="textStyle9">17</span></td>
</tr>
<tr>
<td valign="top"><span class="textStyle9">Resting on the battlefield</span></td>
<td class="right" valign="top"><span class="textStyle9">41</span></td>
</tr>
<tr>
<td valign="top"><span class="textStyle9">A</span> <span class="textStyle4">soldadera</span> <span class="textStyle9">in Calles’s army</span></td>
<td class="right" valign="top"><span class="textStyle9">57</span></td>
</tr>
<tr>
<td valign="top"><span class="textStyle9">Gompers visits Obregón and Calles</span></td>
<td class="right" valign="top"><span class="textStyle9">100</span></td>
</tr>
<tr>
<td valign="top"><span class="textStyle9">The presidential inauguration</span></td>
<td class="right" valign="top"><span class="textStyle9">114</span></td>
</tr>
<tr>
<td valign="top"><span class="textStyle9">The Elías Calles-Chacón family in 1926</span></td>
<td class="right" valign="top"><span class="textStyle9">136</span></td>
</tr>
<tr>
<td valign="top"><span class="textStyle9">On the way to exile</span></td>
<td class="right" valign="top"><span class="textStyle9">184</span></td>
</tr>
<tr>
<td valign="top"><span class="textStyle9">A demonstration of national unity</span></td>
<td class="right" valign="top"><span class="textStyle9">194</span></td>
</tr>
<tr>
<td valign="top"><span class="textStyle9">Front side of “Calles” 100,000-peso bill</span></td>
<td class="right" valign="top"><span class="textStyle9">203</span></td>
</tr>
<tr>
<td valign="top"><span class="textStyle9">Reverse side of “Calles” new 100-peso bill</span></td>
<td class="right" valign="top"><span class="textStyle9">203</span></td>
</tr>
</tbody></table>
<h2 class="h2" id="sigil_toc_id_5"><span class="textStyle014">Maps</span></h2>
<table width="99%">
<tbody><tr>
<td valign="top"><span class="textStyle9">1.1.    Sonora in 1910</span></td>
<td class="right" valign="top"><span class="textStyle9">7</span></td>
</tr>
<tr>
<td valign="top"><span class="textStyle9">1.2.    Mexico in 1910</span></td>
<td class="right" valign="top"><span class="textStyle9">13</span></td>
</tr>
</tbody></table>
<h2 class="h2" id="sigil_toc_id_6"><span class="textStyle014">Tables</span></h2>
<table width="99%">
<tbody><tr>
<td valign="top"><span class="textStyle9">1.1.    The Immediate Family of Plutarco Elías Campuzano</span></td>
<td class="right" valign="top"><span class="textStyle9">10</span></td>
</tr>
<tr>
<td valign="top"><span class="textStyle9">4.1.    The Elías Calles-Chacón Clan</span></td>
<td class="right" valign="top"><span class="textStyle9">95</span></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// IllustrationsandTables.vue?44caffb1